import React, { useEffect, useState } from 'react'
import { Text } from '../../../../../_components/Typography/Components/Text/Text'
import styled from 'styled-components'

import colors from '../../../../../_constants/colors'
import { FaCheck } from 'react-icons/fa'
import { isEmpty } from 'lodash'
import { formatCurrency } from 'legacy/_helpers'

export const S_Checkmark = styled.span`
  display: block;
  padding: 5px;

  svg {
    color: ${colors.FINVOICE_BLUE};
  }
  p {
    display: inline-block;
    padding-left: 15px;
  }
`

const getInvoiceScheduleTerms = (invoiceSchedule) => {
  const selectedTerms = []
  invoiceSchedule.terms.forEach((term) => selectedTerms.push({ id: term.id, name: term.name }))
  return selectedTerms
}

export const SelectedTerms = ({ invoiceSchedule }) => {
  const [invoiceTerms, setInvoiceTerms] = useState([])

  useEffect(() => {
    async function fetchSelectedTerms() {
      const selectedTerms = await getInvoiceScheduleTerms(invoiceSchedule)
      if (Number(invoiceSchedule.minimum_fee_per_invoice)) {
        selectedTerms.push({
          id: 'minimumFactoringFee',
          name: `Minimum Factoring Fee - ${formatCurrency(invoiceSchedule.minimum_fee_per_invoice)}`,
        })
      }
      setInvoiceTerms(selectedTerms)
    }
    fetchSelectedTerms()
  }, [])

  const CheckedTerms = () => {
    return invoiceTerms.map((term) => (
      <S_Checkmark key={term.id}>
        <FaCheck className="fa-solid" />
        <Text fs={'14px'}>{term.name}</Text>
      </S_Checkmark>
    ))
  }

  return (
    <>
      <Text fs={'16px'} pb={'10px'}>
        {'Selected Terms'}
      </Text>

      {!isEmpty(invoiceTerms) && <CheckedTerms />}
    </>
  )
}
